import { createAction } from "redux-actions";

export const setAdminAuthCredentials = createAction(
  "ADMIN_AUTH_SET_CREDENTIALS"
);
